import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class WarehouseStockReconciliationActivity extends Component {

    constructor(props){
        super(props)
        this.RenderedComponent = import("app/components/Accounting/StockReconciliation/StockReconciliationBrowser")
    }

    render() {
        return (
            <Activity 
                name="WarehouseStockReconciliation"
                RenderedComponent={this.RenderedComponent}
                context="WarehouseStockReconciliation"
            />
        )
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(WarehouseStockReconciliationActivity)
